import { connect } from "react-redux";
import * as currency from "../../helpers/currency";
import {
  amountToCurrency,
  amountToCurrencyOrEmpty,
} from "../../helpers/currency";

const CurrencyComponent = ({
  amount,
  defaultCurrency,
  selectedCurrency,
  allowEmpty,
}) => {
  let displayAmount;
  if (allowEmpty) {
    displayAmount = amountToCurrencyOrEmpty(
      amount,
      defaultCurrency,
      selectedCurrency
    );
  } else {
    displayAmount = amountToCurrency(amount, defaultCurrency, selectedCurrency);
  }

  return displayAmount;
};

export const Currency = connect((state, ownProps) => {
  const defaultCurrency =
    state.appSettings?.data?.default_currency || currency.BGN;
  return {
    defaultCurrency: defaultCurrency,
    selectedCurrency:
      ownProps.selectedCurrency ||
      state.currency?.selectedCurrency ||
      defaultCurrency,
  };
})(CurrencyComponent);
